<template>
    <div class="btns-count">
        <div class="home-shop">
            <div class="home-jump">
                <div style="text-align: center;">
                    <img class="jump-img" src="@/assets/home.png" alt="">
                    <div class="jump-title">首页</div>
                </div>
                <div style="text-align: center; margin-left: 15px;">
                    <img class="jump-img" src="@/assets/card.png" alt="">
                    <div class="jump-title">购物袋</div>
                </div>
            </div>
            <div class="jump-btns">
                <div class="btns-c">加入购物袋</div>
                <div class="btns-c btns-bg">立即购买</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // 底部按钮
    name: 'VantBtns',
    props: {
        byType: {
            type: Number,
            default: 0,
            required: false
        }
    },
    data() {
        return {

        }
    },

    created() {

    },

    methods: {

    },
    mounted() {

    },
}
</script>

<style>
    .btns-count {
        padding: 8px 12px;
        background: #fff;
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 10;
        width: calc(100%);
        display: flex;
        justify-content: space-between;
    }

    .home-shop {
        display: flex;
    }

    .home-jump {
        display: flex;
        vertical-align: middle;
    }

    .jump-img {
        width: 25px;
        height: 25px;
    }

    .jump-title {
        font-size: 12px;
        width: 36px;
    }

    .jump-btns {
        display: flex;
        margin-left: 12px;
        vertical-align: middle;
        padding-top: 6px;
    }
    .btns-c {
        width: 120px;
        height: 44px;
        opacity: 1;
        border: 1px solid #FF1341;
        font-size: 14px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FF1341;
        line-height: 44px;
        text-align: center;
        border-radius: 44px;
    }

    .btns-bg {
        background: linear-gradient(36deg, #FF5E9B 0%, #FF1341 100%);
        color: #fff;
        margin-left: 8px;
    }
</style>
